// extracted by mini-css-extract-plugin
module.exports = {"answerInput":"_03ff2bab","correct":"be02490d","incorrect":"be5fe233"};